/* VASTRIO - pre-launch landing page */
(function () {
  'use strict';

  function track(name, params) {
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', name, params || {});
      }
      if (typeof window.fbq === 'function') {
        window.fbq('trackCustom', name, params || {});
      }
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, params || {}));
    } catch (e) { /* analytics must never break the page */ }
  }

  function lock(on) {
    document.body.classList.toggle('vp-lock', !!on);
  }

  /* ---------- reveal ---------- */
  function reveal() {
    var nodes = document.querySelectorAll('.vp-rv');
    if (!nodes.length) return;
    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(nodes, function (n) { n.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e, i) {
        if (!e.isIntersecting) return;
        var el = e.target;
        setTimeout(function () { el.classList.add('in'); }, (i % 3) * 90);
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    Array.prototype.forEach.call(nodes, function (n) { io.observe(n); });
  }

  /* ---------- early list modal + confirmation ----------
     Shopify sends a successful signup back to this page with
     ?customer_posted=true (and the form block marks it). On that return the
     modal opens straight on the thank-you panel; once closed, a small
     confirmation stays on screen. A failed signup reopens the form so the
     error is visible instead of hiding behind a closed modal. */
  function modal() {
    var box = document.querySelector('[data-vp-modal]');
    if (!box) return;
    var panels = {
      form: box.querySelector('[data-vp-panel="form"]'),
      thanks: box.querySelector('[data-vp-panel="thanks"]')
    };
    var toast = document.querySelector('[data-vp-toast]');
    var lastFocus = null;
    var showing = 'form';

    function show(name) {
      showing = panels[name] ? name : 'form';
      Object.keys(panels).forEach(function (k) {
        if (!panels[k]) return;
        if (k === showing) panels[k].removeAttribute('hidden');
        else panels[k].setAttribute('hidden', '');
      });
      box.classList.toggle('is-thanks', showing === 'thanks');
      var title = showing === 'thanks'
        ? box.querySelector('[data-vp-thanks-title]')
        : box.querySelector('#vpModalTitle');
      if (title && title.id) box.setAttribute('aria-labelledby', title.id);
      else if (title) {
        title.id = 'vpThanksTitle';
        box.setAttribute('aria-labelledby', 'vpThanksTitle');
      }
    }

    function open(source, panel) {
      lastFocus = document.activeElement;
      show(panel || 'form');
      if (toast) toast.setAttribute('hidden', '');
      box.classList.add('is-open');
      lock(true);
      if (showing === 'form') track('early_list_open', { source: source || 'unknown' });
      setTimeout(function () {
        var target = showing === 'thanks'
          ? box.querySelector('.vp-thanks__btn')
          : (box.querySelector('[aria-invalid="true"]') || box.querySelector('input:not([type=hidden])'));
        if (target) target.focus();
      }, 320);
    }

    function close() {
      var wasThanks = showing === 'thanks';
      box.classList.remove('is-open');
      lock(false);
      if (lastFocus && lastFocus !== document.body) lastFocus.focus();
      // the next time someone opens it, they get the form again
      setTimeout(function () { show('form'); }, 420);
      if (wasThanks && toast) {
        toast.removeAttribute('hidden');
        requestAnimationFrame(function () { toast.classList.add('is-in'); });
      }
    }

    function visibleFocusables() {
      return Array.prototype.filter.call(
        box.querySelectorAll('a[href], button, input:not([type=hidden]), [tabindex="0"]'),
        function (el) { return el.offsetParent !== null && !el.disabled; }
      );
    }

    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-vp-open]');
      if (opener) {
        e.preventDefault();
        open(opener.getAttribute('data-vp-open'), 'form');
        return;
      }
      if (e.target.closest('[data-vp-close]') || e.target.classList.contains('vp-modal__veil')) {
        e.preventDefault();
        close();
        return;
      }
      if (toast && e.target.closest('[data-vp-toast-close]')) {
        toast.classList.remove('is-in');
        setTimeout(function () { toast.setAttribute('hidden', ''); }, 300);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (!box.classList.contains('is-open')) return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      var f = visibleFocusables();
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    var params = window.location.search;
    var posted = /[?&]customer_posted=true/.test(params) || !!box.querySelector('[data-vp-posted]');
    var failed = !!box.querySelector('[data-vp-error]');

    if (posted && !failed) {
      track('early_list_signup', { source: 'password_page' });
      // drop the flag from the address bar so a refresh does not thank them twice
      try {
        var clean = window.location.pathname + params
          .replace(/([?&])customer_posted=true(&|$)/, function (m, a, b) { return b ? a : ''; })
          .replace(/[?&]$/, '');
        window.history.replaceState(null, '', clean);
      } catch (err) {}
      setTimeout(function () { open('confirmation', 'thanks'); }, 350);
    } else if (failed) {
      setTimeout(function () { open('error', 'form'); }, 350);
    }
  }

  /* ---------- form submit ---------- */
  function forms() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-vp-form]'), function (form) {
      form.addEventListener('submit', function () {
        var btn = form.querySelector('button[type=submit]');
        if (btn) {
          btn.disabled = true;
          btn.textContent = btn.getAttribute('data-sending') || 'Joining';
        }
        track('early_list_submit', { source: form.getAttribute('data-vp-form') || 'form' });
      });
    });
  }

  /* ---------- storefront password ---------- */
  function storePassword() {
    var wrap = document.querySelector('[data-vp-pw]');
    if (!wrap) return;

    function show(focus) {
      wrap.removeAttribute('hidden');
      var field = wrap.querySelector('input[type=password]');
      if (focus && field) field.focus();
    }

    // the team's quiet way in: /password#enter
    function fromHash() {
      if (window.location.hash === '#enter') {
        show(true);
        wrap.scrollIntoView({ block: 'center' });
      }
    }

    var toggle = document.querySelector('[data-vp-pw-toggle]');
    if (toggle) {
      toggle.addEventListener('click', function () {
        if (wrap.hasAttribute('hidden')) show(true);
        else wrap.setAttribute('hidden', '');
      });
    }

    if (wrap.getAttribute('data-has-error') === 'true') show(false);
    fromHash();
    window.addEventListener('hashchange', fromHash);
  }

  /* ---------- parallax fallback ----------
     Chrome, Edge and Safari run the drift from CSS scroll-driven
     animations. Firefox has no support, so the same motion is driven
     here from rAF. No polyfill, and nothing runs when the browser
     already handles it or the visitor asked for less motion. */
  function parallax() {
    if (!('IntersectionObserver' in window) || !window.requestAnimationFrame) return;
    try {
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (window.CSS && CSS.supports &&
          CSS.supports('(animation-timeline: view()) and (animation-range: entry)')) return;
    } catch (e) { return; }

    var layers = [];
    var hero = document.querySelector('.vp-hero');
    var heroBg = hero ? hero.querySelector('.vp-hero__bg') : null;
    if (heroBg) layers.push({ el: heroBg, wrap: hero, amp: 0.035, zoom: 1, on: false });

    var amps = [0.04, 0.065, 0.05];
    Array.prototype.forEach.call(document.querySelectorAll('.vp-tile'), function (tile, i) {
      var wrap = tile.querySelector('.vp-tile__img');
      var img = wrap ? wrap.querySelector('img') : null;
      if (img) layers.push({ el: img, wrap: wrap, amp: amps[i % amps.length], zoom: 1.16, on: false });
    });
    if (!layers.length) return;

    document.documentElement.classList.add('vp-js-parallax');

    var listening = false;
    var ticking = false;

    function place(layer) {
      var box = layer.wrap.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      // 0 as the wrapper enters at the bottom, 1 as it leaves at the top
      var p = (vh - box.top) / (vh + box.height);
      if (p < 0) p = 0;
      else if (p > 1) p = 1;
      var shift = (p * 2 - 1) * layer.amp * layer.el.offsetHeight;
      layer.el.style.transform =
        'translate3d(0,' + shift.toFixed(2) + 'px,0) scale(' + layer.zoom + ')';
    }

    function frame() {
      ticking = false;
      for (var i = 0; i < layers.length; i++) {
        if (layers[i].on) place(layers[i]);
      }
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(frame);
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        layers.forEach(function (layer) {
          if (layer.wrap !== entry.target) return;
          layer.on = entry.isIntersecting;
          if (entry.isIntersecting) place(layer);
        });
      });
      var visible = false;
      layers.forEach(function (layer) { if (layer.on) visible = true; });
      if (visible && !listening) {
        window.addEventListener('scroll', onScroll, { passive: true });
        listening = true;
      } else if (!visible && listening) {
        window.removeEventListener('scroll', onScroll);
        listening = false;
      }
    }, { rootMargin: '12% 0px' });

    layers.forEach(function (layer) { io.observe(layer.wrap); });
    window.addEventListener('resize', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- hero loop ----------
     The still is the poster. Nothing is fetched until we know the visitor
     wants motion and is not on a metered connection, and the loop pauses
     whenever the hero leaves the screen. */
  function heroVideo() {
    var v = document.querySelector('[data-vp-video]');
    if (!v) return;

    try {
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    } catch (e) { return; }

    var net = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (net && (net.saveData || /(^|-)2g$/.test(net.effectiveType || ''))) return;

    var all = Array.prototype.slice.call(v.querySelectorAll('source[data-src]'));
    if (!all.length) return;

    // phones get the portrait loop when there is one; everyone else, or a
    // phone with no portrait loop configured, gets the landscape loop
    var narrow = false;
    try { narrow = window.matchMedia('(max-width: 640px)').matches; } catch (e) {}
    var pick = function (kind) {
      return all.filter(function (s) { return (s.getAttribute('data-for') || 'desktop') === kind; });
    };
    var use = narrow && pick('mobile').length ? pick('mobile') : pick('desktop');
    if (!use.length) use = all;

    all.forEach(function (s) {
      if (use.indexOf(s) === -1) s.parentNode.removeChild(s);
    });
    if (narrow && use[0] && use[0].getAttribute('data-for') === 'mobile') {
      v.setAttribute('width', '1080');
      v.setAttribute('height', '1920');
    }

    v.addEventListener('playing', function () { v.classList.add('is-on'); }, { once: true });

    use.forEach(function (s) { s.src = s.getAttribute('data-src'); });
    v.load();

    function start() {
      var played = v.play();
      if (played && played.catch) {
        played.catch(function () { /* autoplay refused, the still stands */ });
      }
    }
    start();

    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) start();
        else if (!v.paused) v.pause();
      });
    }, { threshold: 0.01 });
    io.observe(v);
  }

  function init() {
    reveal();
    modal();
    forms();
    storePassword();
    parallax();
    heroVideo();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
